import * as SwitchPrimitive from '@radix-ui/react-switch'
import { cva, VariantProps } from 'class-variance-authority'
import { ComponentProps } from 'react'

import { cn } from '@/shared/lib'

const switchVariants = cva(
  [
    'relative cursor-pointer rounded-2xl bg-gray-300 disabled:cursor-default disabled:bg-gray-100',
    'focus-visible:ring-2 focus-visible:ring-gray-200',
  ],
  {
    variants: {
      color: {
        primary:
          'data-[state=checked]:bg-purple-500 data-[state=checked]:focus-visible:ring-purple-200 data-[state=checked]:disabled:bg-purple-200',
        secondary:
          'data-[state=checked]:bg-black data-[state=checked]:disabled:bg-gray-300',
      },
      size: {
        small: 'h-4 w-7',
        medium: 'h-5 w-9',
        large: 'h-6 w-11',
      },
    },
  },
)

const thumbVariants = cva(
  'block translate-x-0.5 rounded-full bg-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.10)] transition-transform duration-300 will-change-transform',
  {
    variants: {
      color: {
        primary: '',
        secondary: '',
      },
      size: {
        small: 'h-3 w-3 data-[state=checked]:translate-x-3.5',
        medium: 'h-4 w-4 data-[state=checked]:translate-x-4.5',
        large: 'h-5 w-5 data-[state=checked]:translate-x-5.5',
      },
    },
  },
)

type Props = ComponentProps<typeof SwitchPrimitive.Root> &
  VariantProps<typeof switchVariants>

export const Switch = ({
  className,
  color = 'primary',
  size = 'large',
  ...props
}: Props) => {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(switchVariants({ color, size, className }))}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={thumbVariants({ color, size })}
      />
    </SwitchPrimitive.Root>
  )
}
